import Hashids from 'hashids'

const hashids = new Hashids('ondata_portal', 6)

export const genUrlWithHashid = (urlTmpStr: string, id: number, idPadName?: string | null) => {
  const left = (new Date()).getMilliseconds() % 128
  const hId = idPadName ? `${encodeURIComponent(idPadName.replace(/[$&+,:;=?@#|'<>.^*()%!~`{}[\]]/g, '').replace('\\', ''))}-${hashids.encode(left, id)}` : hashids.encode(left, id)
  return urlTmpStr.replace('$0', hId)
}

export const decodeHashid = (hashidPortion: string): number => {
  const i = hashidPortion.lastIndexOf('-')
  const hId = hashidPortion.substring(i + 1)
  return (hashids.decode(hId)[1] || 0) as number
}

export const hEncode = (...rest:any[]) => hashids.encode(...rest)
